export default "__VITE_ASSET__tmSYiKZP__"